import {
  EditIcon,
  FilterIcon,
  type IconProps,
  InfoOutlineIcon,
  SettingsIcon,
  TableIcon,
} from '@carboncopyco/icons';
import {
  TextLargeParagraphTitle,
  Tooltip,
  TooltipMessage,
} from '@carboncopyco/ui';
import { useRef } from 'react';

type SectionType =
  | 'generalSettings'
  | 'selectors'
  | 'modifiers'
  | 'visualization';

const sectionTypeToIcon: Record<SectionType, React.ElementType<IconProps>> = {
  generalSettings: SettingsIcon,
  selectors: FilterIcon,
  modifiers: EditIcon,
  visualization: TableIcon,
};

export interface SectionTitleProps extends Pick<LabelProps, 'tooltipContent'> {
  title: string;
  iconType: SectionType;
}

export const SectionTitle = ({
  title,
  iconType,
  tooltipContent,
}: SectionTitleProps) => {
  const Icon = sectionTypeToIcon[iconType];
  return (
    <div className="flex items-center gap-2 text-ds-natural-400">
      <Icon size={24} />
      <Label
        label={title}
        tooltipContent={tooltipContent}
      />
    </div>
  );
};

interface LabelProps {
  label: string;
  tooltipContent?: React.ReactNode;
}

const Label = ({ label, tooltipContent }: LabelProps) => {
  const anchorRef = useRef<HTMLSpanElement>(null);

  return (
    <span className="flex gap-1 items-center">
      <TextLargeParagraphTitle
        label={label}
        color="text-ds-natural-600"
      />
      {tooltipContent && (
        <>
          <span
            ref={anchorRef}
            className="text-ds-natural-300"
          >
            <InfoOutlineIcon size={16} />
          </span>
          <Tooltip
            anchorRef={anchorRef}
            placement="bottom-start"
            autoCalcArrowPosition
          >
            <TooltipMessage title={<span>{tooltipContent}</span>} />
          </Tooltip>
        </>
      )}
    </span>
  );
};
